(function () {
  var GLOBAL_STATE_KEY = '__PAWUNI_PIXEL__';
  var CONTEXT_KEY = '__PAWUNI_PIXEL_CONTEXT__';
  var GSF_QUEUE_KEY = '__PAWUNI_GSF_QUEUE__';
  var SOURCE = 'pawuni_theme';

  var DEFAULT_CONFIG = {
    debug: false,
    directTagFallback: false,
    pushStandardDataLayerEvents: false,
    dedupeWindowMs: 15000,
  };

  var FBQ_EVENT_MAP = {
    page_view: 'PageView',
    view_item: 'ViewContent',
    add_to_cart: 'AddToCart',
    begin_checkout: 'InitiateCheckout',
    view_cart: 'ViewCart',
    remove_from_cart: 'RemoveFromCart',
  };

  var state = {
    initialized_at: Date.now(),
    config: clone(DEFAULT_CONFIG),
    recent_event_ids: [],
    last_event: null,
    last_cart: null,
    first_page_view_sent: false,
    gsf_page_seeded: false,
  };

  window[GLOBAL_STATE_KEY] = state;
  window[GSF_QUEUE_KEY] = window[GSF_QUEUE_KEY] || [];

  function isObject(value) {
    return value && typeof value === 'object' && !Array.isArray(value);
  }

  function clone(value) {
    if (value == null) return value;
    try {
      return JSON.parse(JSON.stringify(value));
    } catch (error) {
      return value;
    }
  }

  function assign(target) {
    var to = isObject(target) ? target : {};
    for (var index = 1; index < arguments.length; index += 1) {
      var source = arguments[index];
      if (!isObject(source)) continue;
      Object.keys(source).forEach(function (key) {
        to[key] = source[key];
      });
    }
    return to;
  }

  function safeParseJSON(value) {
    if (!value || typeof value !== 'string') return null;
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function normalizePageType(templateName, pathname) {
    var template = String(templateName || '').toLowerCase();
    var path = String(pathname || window.location.pathname || '').toLowerCase();

    if (template.indexOf('product') > -1 || path.indexOf('/products/') > -1) return 'product';
    if (template.indexOf('collection') > -1 || path.indexOf('/collections/') > -1) return 'category';
    if (template.indexOf('cart') > -1 || path === '/cart') return 'cart';
    if (template.indexOf('search') > -1 || path.indexOf('/search') === 0) return 'searchresults';
    if (template.indexOf('index') > -1 || path === '/' || path === '') return 'home';
    if (template.indexOf('article') > -1) return 'article';
    if (template.indexOf('blog') > -1) return 'blog';
    return 'page';
  }

  function toRuntimeTemplateFromBody() {
    if (!document || !document.body || !document.body.className) return '';
    var className = document.body.className;
    var tokens = className.split(/\s+/);
    for (var index = 0; index < tokens.length; index += 1) {
      var token = tokens[index];
      if (!token) continue;
      if (token === 'error-404') return '404';
      return token.replace(/-/g, '.');
    }
    return '';
  }

  function getContext() {
    var raw = window[CONTEXT_KEY];
    var context = isObject(raw) ? clone(raw) : {};
    var runtimeTemplate = toRuntimeTemplateFromBody();

    if (runtimeTemplate && runtimeTemplate !== context.template) {
      context.template = runtimeTemplate;
    }

    if (!context.template) {
      context.template = runtimeTemplate;
    }

    if (context.url && context.url !== window.location.href) {
      context.url = window.location.href;
      context.page_type = normalizePageType(context.template, window.location.pathname);
    }

    context.page_type = context.page_type || normalizePageType(context.template, window.location.pathname);
    context.url = context.url || window.location.href;

    return context;
  }

  function getContextCurrency() {
    var context = getContext();
    var currency =
      (context.currency && (context.currency.presentment || context.currency.shop)) ||
      (window.PXUTheme && window.PXUTheme.currency && window.PXUTheme.currency.iso_code) ||
      (window.PXUTheme && window.PXUTheme.currency && window.PXUTheme.currency.shop_currency) ||
      '';

    return String(currency || '').toUpperCase();
  }

  function centsToMoney(valueInCents) {
    var value = Number(valueInCents);
    if (!isFinite(value)) return 0;
    return Math.round(value) / 100;
  }

  function toNumber(value, fallback) {
    var parsed = Number(value);
    return isFinite(parsed) ? parsed : fallback;
  }

  function generateEventId(eventName) {
    var random = Math.random().toString(36).slice(2, 10);
    return ['pw', String(eventName || 'event'), String(Date.now()), random].join('_');
  }

  function shouldLogDebug() {
    if (state.config.debug === true) return true;
    var query = window.location.search || '';
    return /(?:\?|&)pawuni_pixel_debug=1(?:&|$)/.test(query);
  }

  function logDebug() {
    if (!shouldLogDebug() || !window.console || typeof window.console.log !== 'function') return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[PawuniPixelBridge]');
    window.console.log.apply(window.console, args);
  }

  function buildCustomEvent(name, detail) {
    if (typeof window.CustomEvent === 'function') {
      return new window.CustomEvent(name, { detail: detail });
    }

    var event = document.createEvent('CustomEvent');
    event.initCustomEvent(name, true, true, detail);
    return event;
  }

  function dispatchEvent(name, detail) {
    try {
      document.dispatchEvent(buildCustomEvent(name, detail));
    } catch (error) {
      logDebug('Failed to dispatch event', name, error);
    }
  }

  function getAttribution() {
    try {
      if (window.PawuniAttribution && typeof window.PawuniAttribution.get === 'function') {
        return window.PawuniAttribution.get();
      }
    } catch (error) {
      logDebug('Failed to read PawuniAttribution.get()', error);
    }

    if (isObject(window.__ATTRIBUTION__)) {
      return clone(window.__ATTRIBUTION__);
    }

    return null;
  }

  function getCartAttributes() {
    try {
      if (window.PawuniAttribution && typeof window.PawuniAttribution.toCartAttributes === 'function') {
        return window.PawuniAttribution.toCartAttributes();
      }
    } catch (error) {
      logDebug('Failed to read cart attributes from attribution', error);
    }

    return {};
  }

  function pruneRecentEventIds() {
    var now = Date.now();
    var ttl = toNumber(state.config.dedupeWindowMs, DEFAULT_CONFIG.dedupeWindowMs);

    state.recent_event_ids = state.recent_event_ids.filter(function (entry) {
      return entry && entry.id && now - entry.ts <= ttl;
    });
  }

  function isDuplicateEventId(eventId) {
    pruneRecentEventIds();

    return state.recent_event_ids.some(function (entry) {
      return entry.id === eventId;
    });
  }

  function rememberEventId(eventId) {
    state.recent_event_ids.push({ id: eventId, ts: Date.now() });
    pruneRecentEventIds();
  }

  function buildEnvelope(name, payload, options) {
    var eventName = String(name || '').trim();
    if (!eventName) return null;

    var safePayload = isObject(payload) ? clone(payload) : {};
    var context = getContext();
    var eventId =
      options && options.event_id ? String(options.event_id).trim() : generateEventId(eventName);

    return {
      name: eventName,
      event_id: eventId,
      ts: Date.now(),
      url: window.location.href,
      template: context.template || '',
      page_type: context.page_type || normalizePageType(context.template, window.location.pathname),
      ecommerce: isObject(safePayload.ecommerce) ? safePayload.ecommerce : {},
      attribution: getAttribution(),
      cart_attributes: getCartAttributes(),
      source: SOURCE,
      payload: safePayload,
    };
  }

  function pushToDataLayer(eventName, envelope) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: eventName,
        pawuni_event: envelope,
      });
    } catch (error) {
      logDebug('Failed to push dataLayer event', eventName, error);
    }
  }

  function publishShopifyAnalytics(envelope) {
    try {
      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function'
      ) {
        window.Shopify.analytics.publish('pawuni_pixel_event', envelope);
      }
    } catch (error) {
      logDebug('Failed to publish Shopify analytics event', error);
    }
  }

  function toFallbackTagPayload(envelope) {
    var ecommerce = isObject(envelope.ecommerce) ? envelope.ecommerce : {};
    var items = Array.isArray(ecommerce.items) ? ecommerce.items : [];

    var payload = {
      event_id: envelope.event_id,
    };

    if (typeof ecommerce.value !== 'undefined') {
      payload.value = ecommerce.value;
    }

    if (ecommerce.currency) {
      payload.currency = ecommerce.currency;
    }

    if (items.length) {
      payload.content_type = 'product';
      payload.content_ids = items.map(function (item) {
        return String(item.item_variant_id || item.item_id || '');
      });
      payload.contents = items.map(function (item) {
        return {
          id: String(item.item_variant_id || item.item_id || ''),
          quantity: toNumber(item.quantity, 1),
          item_price: toNumber(item.price, 0),
        };
      });
    }

    return payload;
  }

  function publishDirectTagFallback(envelope) {
    var payload = toFallbackTagPayload(envelope);
    var fallbackFbqEvent = FBQ_EVENT_MAP[envelope.name] || null;

    try {
      if (typeof window.fbq === 'function') {
        if (fallbackFbqEvent) {
          window.fbq('track', fallbackFbqEvent, payload);
        } else {
          window.fbq('trackCustom', envelope.name, payload);
        }
      }
    } catch (error) {
      logDebug('Failed to publish fbq fallback', error);
    }

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', envelope.name, assign({}, payload, {
          items: envelope.ecommerce && Array.isArray(envelope.ecommerce.items) ? envelope.ecommerce.items : [],
        }));
      }
    } catch (error) {
      logDebug('Failed to publish gtag fallback', error);
    }
  }

  function gsfQueueHasEventId(eventId) {
    if (!eventId) return false;
    var queue = window[GSF_QUEUE_KEY];
    if (!Array.isArray(queue)) return false;

    for (var index = 0; index < queue.length; index += 1) {
      var entry = queue[index];
      if (!entry || !entry.event_id) continue;
      if (entry.event_id === eventId) return true;
    }

    return false;
  }

  function queueGsfConversion(conversion) {
    if (!isObject(conversion)) return;

    window.gsf_conversion_data = conversion;
    window[GSF_QUEUE_KEY] = window[GSF_QUEUE_KEY] || [];

    if (!conversion.event_id || !gsfQueueHasEventId(conversion.event_id)) {
      window[GSF_QUEUE_KEY].push(conversion);
    }

    dispatchEvent('gsf:conversion_ready', conversion);
  }

  function toGsfConversion(envelope) {
    var payload = isObject(envelope.payload) ? envelope.payload : {};
    var ecommerce = isObject(envelope.ecommerce) ? envelope.ecommerce : {};
    var data = isObject(payload.data) ? clone(payload.data) : {};

    if (!Array.isArray(data.product_data) && Array.isArray(ecommerce.items)) {
      data.product_data = clone(ecommerce.items);
    }

    if (typeof data.total_price === 'undefined' && typeof ecommerce.value !== 'undefined') {
      data.total_price = ecommerce.value;
    }

    if (!data.shop_currency) {
      data.shop_currency = ecommerce.currency || getContextCurrency();
    }

    return {
      page_type: envelope.page_type || '',
      event: envelope.name || '',
      data: data,
      event_id: envelope.event_id,
      attribution: envelope.attribution,
      source: envelope.source,
    };
  }

  function publishGsfFromEnvelope(envelope) {
    queueGsfConversion(toGsfConversion(envelope));
  }

  function hydrateInitialGsfConversion() {
    if (!isObject(window.gsf_conversion_data)) return;

    var current = clone(window.gsf_conversion_data);
    current.event_id = current.event_id || generateEventId(current.event || 'page_view');

    if (typeof current.attribution === 'undefined') {
      current.attribution = getAttribution();
    }

    current.source = current.source || SOURCE;

    queueGsfConversion(current);
    state.gsf_page_seeded = true;
  }

  function emit(name, payload, options) {
    var opts = isObject(options) ? options : {};
    var envelope = buildEnvelope(name, payload, opts);
    if (!envelope) return null;

    if (isDuplicateEventId(envelope.event_id)) {
      logDebug('Skipped duplicate event', envelope.name, envelope.event_id);
      return envelope;
    }

    rememberEventId(envelope.event_id);

    dispatchEvent('pawuni:pixel_event', envelope);
    pushToDataLayer('pawuni_' + envelope.name, envelope);

    if (state.config.pushStandardDataLayerEvents || opts.push_standard_data_layer_events === true) {
      pushToDataLayer(envelope.name, envelope);
    }

    publishShopifyAnalytics(envelope);

    if (opts.skip_gsf !== true) {
      publishGsfFromEnvelope(envelope);
    }

    if (state.config.directTagFallback || opts.direct_tag_fallback === true) {
      publishDirectTagFallback(envelope);
    }

    state.last_event = clone(envelope);
    return envelope;
  }

  function getState() {
    return clone(state);
  }

  function configure(nextConfig) {
    if (!isObject(nextConfig)) return getState();

    var currentConfig = clone(state.config || DEFAULT_CONFIG);
    state.config = assign(currentConfig, nextConfig);

    dispatchEvent('pawuni:pixel_ready', {
      state: getState(),
      config: clone(state.config),
    });

    return getState();
  }

  function cartItemToEcommerceItem(item) {
    if (!isObject(item)) return null;

    var priceInCents =
      typeof item.final_price !== 'undefined'
        ? item.final_price
        : typeof item.price !== 'undefined'
          ? item.price
          : 0;

    return {
      item_id: String(item.product_id || item.id || ''),
      item_variant_id: String(item.variant_id || item.id || ''),
      item_name: item.product_title || item.title || '',
      item_brand: item.vendor || '',
      item_category: item.product_type || item.type || '',
      item_variant: item.variant_title || '',
      price: centsToMoney(priceInCents),
      quantity: toNumber(item.quantity, 1),
    };
  }

  function addResponseItemToEcommerceItem(item) {
    if (!isObject(item)) return null;

    return {
      item_id: String(item.product_id || item.id || ''),
      item_variant_id: String(item.variant_id || item.id || ''),
      item_name: item.product_title || item.title || '',
      item_brand: item.vendor || '',
      item_category: item.product_type || item.type || '',
      item_variant: item.variant_title || '',
      price: centsToMoney(item.final_price || item.price || 0),
      quantity: toNumber(item.quantity, 1),
    };
  }

  function buildEcommerceFromCart(cart) {
    var items = [];

    if (isObject(cart) && Array.isArray(cart.items)) {
      items = cart.items
        .map(cartItemToEcommerceItem)
        .filter(function (item) {
          return isObject(item);
        });
    }

    return {
      currency: (cart && cart.currency) || getContextCurrency(),
      value: centsToMoney((cart && cart.total_price) || 0),
      items: items,
    };
  }

  function toCartPayload(cart) {
    if (!isObject(cart)) return null;

    return {
      token: cart.token || null,
      item_count: toNumber(cart.item_count, 0),
      total_price: centsToMoney(cart.total_price || 0),
      currency: cart.currency || getContextCurrency(),
      items: Array.isArray(cart.items)
        ? cart.items
            .map(cartItemToEcommerceItem)
            .filter(function (item) {
              return isObject(item);
            })
        : [],
    };
  }

  function normalizeRequestPath(url) {
    if (!url) return '';

    try {
      var normalized = new URL(url, window.location.origin);
      return normalized.pathname;
    } catch (error) {
      var raw = String(url);
      var withoutOrigin = raw.replace(/^https?:\/\/[^/]+/i, '');
      return withoutOrigin.split('?')[0].split('#')[0];
    }
  }

  function readJsonFromFetchResponse(response) {
    if (!response || typeof response.clone !== 'function') {
      return Promise.resolve(null);
    }

    return response
      .clone()
      .json()
      .catch(function () {
        return null;
      });
  }

  function readJsonFromXhr(xhr) {
    if (!xhr || typeof xhr.responseText !== 'string') return null;
    return safeParseJSON(xhr.responseText);
  }

  function bodyToString(body) {
    if (!body) return '';
    if (typeof body === 'string') return body;

    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      return body.toString();
    }

    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      var params = new URLSearchParams();
      body.forEach(function (value, key) {
        params.append(key, value);
      });
      return params.toString();
    }

    if (isObject(body)) {
      var pairs = [];
      Object.keys(body).forEach(function (key) {
        pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(body[key]));
      });
      return pairs.join('&');
    }

    return String(body);
  }

  function parseRequestBody(body) {
    var raw = bodyToString(body);
    if (!raw) return {};
    var result = {};

    function assignParam(key, value) {
      if (Object.prototype.hasOwnProperty.call(result, key)) {
        if (!Array.isArray(result[key])) {
          result[key] = [result[key]];
        }
        result[key].push(value);
      } else {
        result[key] = value;
      }
    }

    if (typeof URLSearchParams !== 'undefined') {
      var params = new URLSearchParams(raw);
      params.forEach(function (value, key) {
        assignParam(key, value);
      });
      return result;
    }

    raw.split('&').forEach(function (pair) {
      if (!pair) return;
      var parts = pair.split('=');
      var key = decodeURIComponent(parts.shift() || '');
      var value = decodeURIComponent(parts.join('=') || '');
      assignParam(key, value);
    });

    return result;
  }

  function getCartSnapshot(options) {
    if (typeof window.fetch !== 'function') {
      return Promise.reject(new Error('Fetch is not available'));
    }

    var opts = isObject(options) ? options : {};

    return window
      .fetch('/cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        keepalive: opts.keepalive === true,
      })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Failed to fetch cart snapshot');
        }
        return response.json();
      })
      .then(function (cart) {
        if (isObject(cart)) {
          state.last_cart = clone(cart);
        }
        return cart;
      });
  }

  function getRemovedItems(prevCart, nextCart) {
    if (!isObject(prevCart) || !isObject(nextCart)) return [];

    var prevMap = {};
    var nextMap = {};
    var removed = [];

    (prevCart.items || []).forEach(function (item) {
      if (!item) return;
      var key = item.key || String(item.variant_id || item.id || '');
      prevMap[key] = item;
    });

    (nextCart.items || []).forEach(function (item) {
      if (!item) return;
      var key = item.key || String(item.variant_id || item.id || '');
      nextMap[key] = item;
    });

    Object.keys(prevMap).forEach(function (key) {
      var prevItem = prevMap[key];
      var nextItem = nextMap[key];
      var prevQty = toNumber(prevItem && prevItem.quantity, 0);
      var nextQty = toNumber(nextItem && nextItem.quantity, 0);

      if (prevQty <= nextQty) return;

      var removedItem = cartItemToEcommerceItem(prevItem);
      if (!removedItem) return;
      removedItem.quantity = prevQty - nextQty;
      removed.push(removedItem);
    });

    return removed;
  }

  function handleAddToCartResponse(item, meta) {
    var addedItem = addResponseItemToEcommerceItem(item);
    if (!addedItem) return;

    getCartSnapshot()
      .then(function (cart) {
        emit(
          'add_to_cart',
          {
            ecommerce: {
              currency: cart.currency || getContextCurrency(),
              value: toNumber(addedItem.price, 0) * toNumber(addedItem.quantity, 1),
              items: [addedItem],
            },
            cart: toCartPayload(cart),
            endpoint: '/cart/add.js',
            transport: meta.transport,
          },
          { skip_gsf: false },
        );
      })
      .catch(function () {
        emit(
          'add_to_cart',
          {
            ecommerce: {
              currency: getContextCurrency(),
              value: toNumber(addedItem.price, 0) * toNumber(addedItem.quantity, 1),
              items: [addedItem],
            },
            endpoint: '/cart/add.js',
            transport: meta.transport,
          },
          { skip_gsf: false },
        );
      });
  }

  function handleCartMutationResponse(cart, meta, path) {
    if (!isObject(cart)) return;

    var previousCart = isObject(state.last_cart) ? clone(state.last_cart) : null;
    state.last_cart = clone(cart);

    emit('cart_updated', {
      ecommerce: buildEcommerceFromCart(cart),
      cart: toCartPayload(cart),
      endpoint: path,
      transport: meta.transport,
      request_body: parseRequestBody(meta.body),
    });

    var removedItems = getRemovedItems(previousCart, cart);
    if (!removedItems.length) return;

    var removedValue = removedItems.reduce(function (sum, item) {
      return sum + toNumber(item.price, 0) * toNumber(item.quantity, 1);
    }, 0);

    emit('remove_from_cart', {
      ecommerce: {
        currency: cart.currency || getContextCurrency(),
        value: removedValue,
        items: removedItems,
      },
      cart: toCartPayload(cart),
      endpoint: path,
      transport: meta.transport,
      request_body: parseRequestBody(meta.body),
    });
  }

  function handleCartSnapshotResponse(cart) {
    if (!isObject(cart)) return;
    state.last_cart = clone(cart);
  }

  function resolveNetworkJson(meta) {
    if (meta.response) return readJsonFromFetchResponse(meta.response);
    return Promise.resolve(readJsonFromXhr(meta.xhr));
  }

  function handleNetworkResponse(meta) {
    var path = normalizeRequestPath(meta.url);
    if (!path) return;

    if (path === '/cart/add.js') {
      resolveNetworkJson(meta).then(function (json) {
        if (isObject(json)) {
          handleAddToCartResponse(json, meta);
        }
      });
      return;
    }

    if (path === '/cart/change.js' || path === '/cart/update.js') {
      resolveNetworkJson(meta).then(function (json) {
        if (isObject(json)) {
          handleCartMutationResponse(json, meta, path);
        }
      });
      return;
    }

    if (path === '/cart.js') {
      resolveNetworkJson(meta).then(function (json) {
        if (isObject(json)) {
          handleCartSnapshotResponse(json);
        }
      });
    }
  }

  function getFetchUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function getFetchMethod(input, init) {
    if (init && init.method) return String(init.method).toUpperCase();
    if (input && input.method) return String(input.method).toUpperCase();
    return 'GET';
  }

  function patchFetch() {
    if (typeof window.fetch !== 'function') return;
    if (window.fetch.__pawuniPatched) return;

    var originalFetch = window.fetch;

    var wrappedFetch = function (input, init) {
      var url = getFetchUrl(input);
      var method = getFetchMethod(input, init);
      var body = init && init.body;

      return originalFetch.apply(this, arguments).then(function (response) {
        if (response && response.ok) {
          handleNetworkResponse({
            transport: 'fetch',
            url: url,
            method: method,
            body: body,
            response: response,
          });
        }

        return response;
      });
    };

    wrappedFetch.__pawuniPatched = true;
    wrappedFetch.__pawuniOriginal = originalFetch;
    window.fetch = wrappedFetch;
  }

  function patchXMLHttpRequest() {
    if (!window.XMLHttpRequest || !window.XMLHttpRequest.prototype) return;

    var proto = window.XMLHttpRequest.prototype;
    if (proto.open.__pawuniPatched || proto.send.__pawuniPatched) return;

    var originalOpen = proto.open;
    var originalSend = proto.send;

    proto.open = function (method, url) {
      this.__pawuniMethod = method;
      this.__pawuniUrl = url;
      return originalOpen.apply(this, arguments);
    };

    proto.open.__pawuniPatched = true;

    proto.send = function (body) {
      this.__pawuniBody = body;

      this.addEventListener('load', function () {
        if (this.status < 200 || this.status >= 400) return;

        handleNetworkResponse({
          transport: 'xhr',
          url: this.__pawuniUrl,
          method: String(this.__pawuniMethod || 'GET').toUpperCase(),
          body: this.__pawuniBody,
          xhr: this,
        });
      });

      return originalSend.apply(this, arguments);
    };

    proto.send.__pawuniPatched = true;
  }

  function parseProductJsonFromForm(form) {
    if (!form || typeof form.getAttribute !== 'function') return null;

    var json = form.getAttribute('data-product');
    if (!json) return null;

    return safeParseJSON(json);
  }

  function findSelectedVariant(product, form) {
    if (!isObject(product) || !Array.isArray(product.variants)) return null;

    var selectedId = null;

    if (form && typeof form.querySelector === 'function') {
      var selectedInput = form.querySelector('[name="id"]');
      if (selectedInput && selectedInput.value) {
        selectedId = String(selectedInput.value);
      }
    }

    if (!selectedId && product.selected_or_first_available_variant) {
      selectedId = String(product.selected_or_first_available_variant.id || '');
    }

    for (var index = 0; index < product.variants.length; index += 1) {
      var variant = product.variants[index];
      if (String(variant.id) === selectedId) return variant;
    }

    return product.variants[0] || null;
  }

  function productToEcommerceItem(product, variant) {
    if (!isObject(product) || !isObject(variant)) return null;

    return {
      item_id: String(product.id || ''),
      item_variant_id: String(variant.id || ''),
      item_name: product.title || '',
      item_brand: product.vendor || '',
      item_category: product.type || '',
      item_variant: variant.title || '',
      price: centsToMoney(variant.price || 0),
      quantity: 1,
    };
  }

  function emitViewItemIfAvailable() {
    var context = getContext();
    if (context.page_type !== 'product') return;

    var form = document.querySelector('[data-product-form][data-product]');
    var product = parseProductJsonFromForm(form);

    if (!isObject(product)) {
      var productContext = isObject(context.product) ? context.product : null;
      var selectedVariant = productContext && isObject(productContext.selected_variant) ? productContext.selected_variant : null;

      if (!productContext || !selectedVariant) return;

      var fallbackItem = {
        item_id: String(productContext.id || ''),
        item_variant_id: String(selectedVariant.id || ''),
        item_name: productContext.title || '',
        item_brand: productContext.vendor || '',
        item_category: productContext.type || '',
        item_variant: selectedVariant.title || '',
        price: centsToMoney(selectedVariant.price || 0),
        quantity: 1,
      };

      emit('view_item', {
        ecommerce: {
          currency: getContextCurrency(),
          value: fallbackItem.price,
          items: [fallbackItem],
        },
      });
      return;
    }

    var variant = findSelectedVariant(product, form);
    var item = productToEcommerceItem(product, variant);
    if (!item) return;

    emit('view_item', {
      ecommerce: {
        currency: getContextCurrency(),
        value: toNumber(item.price, 0),
        items: [item],
      },
    });
  }

  function emitViewCartIfAvailable() {
    var context = getContext();
    if (context.page_type !== 'cart') return;

    getCartSnapshot()
      .then(function (cart) {
        emit('view_cart', {
          ecommerce: buildEcommerceFromCart(cart),
          cart: toCartPayload(cart),
        });
      })
      .catch(function () {
        emit('view_cart', {
          ecommerce: {
            currency: getContextCurrency(),
            value: 0,
            items: [],
          },
        });
      });
  }

  function emitPageView(options) {
    var opts = isObject(options) ? options : {};

    emit(
      'page_view',
      {
        ecommerce: {
          currency: getContextCurrency(),
        },
        context: getContext(),
      },
      opts,
    );

    state.first_page_view_sent = true;
  }

  function bindCheckoutTracking() {
    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!target || typeof target.closest !== 'function') return;

        var button = target.closest(
          '[data-cart-checkout-button], [data-minicart-checkout-button], button[name="checkout"]',
        );
        if (!button) return;

        var eventId = generateEventId('begin_checkout');

        getCartSnapshot({ keepalive: true })
          .then(function (cart) {
            emit(
              'begin_checkout',
              {
                ecommerce: buildEcommerceFromCart(cart),
                cart: toCartPayload(cart),
                trigger: 'checkout_button',
              },
              { event_id: eventId },
            );
          })
          .catch(function () {
            emit(
              'begin_checkout',
              {
                ecommerce: {
                  currency: getContextCurrency(),
                },
                trigger: 'checkout_button',
              },
              { event_id: eventId },
            );
          });
      },
      true,
    );
  }

  function bindInstantClickTracking() {
    if (!window.InstantClick || typeof window.InstantClick.on !== 'function') return;

    window.InstantClick.on('change', function () {
      emitPageView({ skip_gsf: false });
      emitViewItemIfAvailable();
      emitViewCartIfAvailable();
    });
  }

  function bootstrap() {
    var query = window.location.search || '';
    if (/(?:\?|&)pawuni_pixel_debug=1(?:&|$)/.test(query)) {
      state.config.debug = true;
    }

    hydrateInitialGsfConversion();

    window.PawuniPixelBridge = {
      getState: getState,
      emit: emit,
      configure: configure,
    };

    patchFetch();
    patchXMLHttpRequest();
    bindCheckoutTracking();
    bindInstantClickTracking();

    emitPageView({ skip_gsf: state.gsf_page_seeded === true });
    emitViewItemIfAvailable();
    emitViewCartIfAvailable();

    dispatchEvent('pawuni:pixel_ready', {
      state: getState(),
      config: clone(state.config),
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
